import * as React from 'react';
import * as categoryProductReducer from '@/redux/ui/category-product';
import * as categoryAppReducer from '@/redux/ui/category-app';
import * as ProductEditStore from '@/redux/pages/product-edit';

import ActionSheet from '@/pages/components/common/ui/actionsheet/index';
import CategoryProduct from '@/pages/containers/common/category-product';
import CategoryApp from '@/pages/containers/common/category-app';
import State from './state';
import store from '@/redux/index';

import { types } from '@/redux/ui/actionsheet';
import { parse } from 'query-string';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { PickerBox } from '@/pages/components/picker';
import config from '@/server/config';
import request from '@/server/request';

const Toast = require('react-toast-mobile');

class ProductEdit extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        const searchParams = parse(this.props.location.search);
        this.state = {
            id: searchParams.id || '', // id号
            type: searchParams.type || '1', // 1:生产原材料 2:生产设备
            source: searchParams.source || '1', // 1 添加产品 ， 2， 用户前台编辑，3，认领状态下的编辑，4，查看我的版本
            appearanceList: [
                {
                    name: '固态',
                    value: '1'
                },
                {
                    name: '液态',
                    value: '2'
                },
                {
                    name: '气态',
                    value: '3'
                },
                {
                    name: '粉末',
                    value: '4'
                }
            ],
            modelAppearance: '', // 外观
        };
    }

    public componentDidMount() {

        // 如果是编辑第一次进入页面或者是查看我的版本
        if ((this.state.id && this.props.step === 1) || this.state.source === '4') {
            this.getProInitData();
        } else if (!this.state.id && this.props.step === 1) {
            this.getCompanyName();
        }

    }

    public render() {
        const state = this.state;
        const props = this.props;
        return (
            <section className="expert-edit ylk-edit">
                <State serial={props.step} type={state.type} />
                {
                    props.step === 1 ?
                        <section className="ylk-edit-block">
                            <div className="ylk-edit-wrapper">
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                    选择产品分类
                                </div>
                                    {
                                        state.source !== '4' ?
                                            <div className="expert-editgroup">
                                                <button className="formula-plus" onClick={() => this.addCategory()}><i>+</i>添加</button>
                                            </div> : null
                                    }
                                </div>
                                {
                                    props.proCategory.map((v: any, k: number) => {
                                        return (
                                            <div className="expert-edititem" onClick={() => this.selectProductCategory(k)} key={v.lv1.product_id ? (v.lv1.product_id) + k : k}>
                                                <div className="expert-editgroup formula-select">
                                                    {
                                                        v.lv1.classification_name ?
                                                            <p className="active">
                                                                {v.lv1.classification_name}
                                                                {
                                                                    v.lv2.classification_name ? ('>' + v.lv2.classification_name) : ''
                                                                }
                                                                {
                                                                    v.lv3.classification_name ? ('>' + v.lv3.classification_name) : ''
                                                                }
                                                            </p> :
                                                            <p>请选择</p>
                                                    }

                                                    {
                                                        state.source !== '4' ?
                                                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                                    }
                                                    {
                                                        k > 0 ? <span className="icon-reduce" onClick={e => this.removeCategory(e, k)}>-</span> : null
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                state.type === '1' ?
                                    <div className="ylk-edit-wrapper">
                                        <div className="expert-edititem">
                                            <div className="expert-editlabel">
                                                <span>*</span>
                                    选择应用分类
                                </div>
                                            {
                                                state.source !== '4' ?
                                                    <div className="expert-editgroup">
                                                        <button className="formula-plus" onClick={() => this.addAppCategory()}><i>+</i>添加</button>
                                                    </div> : null
                                            }
                                        </div>
                                        {
                                            props.appCategory.map((v: any, k: number) => {
                                                return (
                                                    <div className="expert-edititem" onClick={() => this.selectAppCategory(k)} key={v.lv1.id ? (v.lv1.id + k) : k}>
                                                        <div className="expert-editgroup formula-select">
                                                            {
                                                                v.lv1.classification_name ?
                                                                    <p className="active">
                                                                        {v.lv1.classification_name}
                                                                        {
                                                                            v.lv2.classification_name ? ('>' + v.lv2.classification_name) : ''
                                                                        }
                                                                        {
                                                                            v.lv3.classification_name ? ('>' + v.lv3.classification_name) : ''
                                                                        }
                                                                        {
                                                                            v.lv4.classification_name ? ('>' + v.lv4.classification_name) : ''
                                                                        }
                                                                    </p> :
                                                                    <p>请选择</p>
                                                            }

                                                            {
                                                                state.source !== '4' ?
                                                                    <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                                            }
                                                            {
                                                                k > 0 ? <span className="icon-reduce" onClick={e => this.removeAppCategory(e, k)}>-</span> : null
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> : null
                            }
                        </section> : null
                }
                {
                    props.step === 2 ?
                        <section className="ylk-edit-block">
                            <div className="ylk-edit-wrapper">
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                    产品中文名称
                                </div>
                                    <div className="expert-editgroup">
                                        <input type="text" placeholder="请填写" onChange={() => this.inputAction('productName')} value={props.productName} readOnly={state.source === '4'} />
                                    </div>
                                </div>
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        产品英文名称
                                </div>
                                    <div className="expert-editgroup">
                                        <input type="text" placeholder="请填写" onChange={() => this.inputAction('productEnName')} value={props.productEnName} readOnly={state.source === '4'} />
                                    </div>
                                </div>
                                {
                                    state.type === '1' ?
                                        <div>
                                            <div className="expert-edititem">
                                                <div className="expert-editlabel">
                                                    产品化学名称
                                            </div>
                                                <div className="expert-editgroup">
                                                    <input type="text" placeholder="请填写" onChange={() => this.inputAction('chemicalName')} value={props.chemicalName} readOnly={state.source === '4'} />
                                                </div>
                                            </div>
                                            <div className="expert-edititem">
                                                <div className="expert-editlabel">
                                                    化学式
                                            </div>
                                                <div className="expert-editgroup">
                                                    <input type="text" placeholder="请填写" onChange={() => this.inputAction('chemicalFormula')} value={props.chemicalFormula} readOnly={state.source === '4'} />
                                                </div>
                                            </div>
                                            <div className="expert-edititem">
                                                <div className="expert-editlabel">
                                                    分子量
                                            </div>
                                                <div className="expert-editgroup">
                                                    <input type="text" placeholder="请填写" onChange={() => this.inputAction('molecular')} value={props.molecular} readOnly={state.source === '4'} />
                                                </div>
                                            </div>
                                            <div className="expert-edititem">
                                                <div className="expert-editlabel">
                                                    CAS号
                                            </div>
                                                <div className="expert-editgroup">
                                                    <input type="text" placeholder="请填写" onChange={() => this.inputAction('cas')} value={props.cas} readOnly={state.source === '4'} />
                                                </div>
                                            </div>
                                            <div className="expert-edititem" onClick={() => this.navigateTo('/u/product/introduction?source=' + state.source, false)}>
                                                <div className="expert-editlabel">
                                                    产品描述
                                            </div>
                                                <div className="expert-editgroup">
                                                    <p className={props.desc ? 'active' : ''}>{props.desc ? '已填写' : '请选择'}</p>
                                                    <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                                                </div>
                                            </div>
                                        </div> : null
                                }
                            </div>
                        </section> : null
                }
                {
                    state.type === '1' && props.step === 3 && 
                    <section className="ylk-edit-block">
                        <div className="ylk-edit-wrapper">
                            <div className="expert-edititem" onClick={() => this.uploadFile('tds')}>
                                <div className="expert-editlabel">
                                    产品TDS
                            </div>
                            <div className="expert-editgroup">
                                <p className={props.tds ? 'active' : ''}>{props.tds ? '已上传' : '请上传'}</p>
                                {
                                    state.source !== '4' ?
                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                }
                            </div>
                        </div>
                        <div className="expert-edititem" onClick={() => this.uploadFile('msds')}>
                            <div className="expert-editlabel">
                                产品MSDS
                            </div>
                            <div className="expert-editgroup">
                                <p className={props.msds ? 'active' : ''}>{props.msds ? '已上传' : '请上传'}</p>
                                {
                                    state.source !== '4' ?
                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                }
                            </div>
                        </div>
                        </div>
                    </section>
                }
                {
                   (state.type !== '1' && props.step === 3) || props.step === 4 ?
                        <section className="ylk-edit-block">
                            <div className="ylk-edit-wrapper">
                                <div className="expert-edititem" onClick={() => this.navigateToManufacturer('/u/product/selectmanufacturer?type=1')}>
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                    供应商
                                </div>
                                    <div className="expert-editgroup">
                                        <p className={props.munufacturer_name ? 'active' : ''}>{props.munufacturer_name || '请选择'}</p>
                                        {
                                            state.source < 3 ?
                                                <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                        }
                                    </div>
                                </div>
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                    牌号
                                </div>
                                    <div className="expert-editgroup">
                                        <input type="text" placeholder="请输入" onChange={() => this.inputAction('brand')} value={props.brand} readOnly={state.source === '4'} />
                                    </div>
                                </div>
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                    产品型号
                                </div>
                                    <div className="expert-editgroup">
                                        <input type="text" placeholder="请输入" onChange={() => this.inputAction('model')} value={props.model} readOnly={state.source === '4'} />
                                    </div>
                                </div>
                                <div className="expert-edititem" onClick={() => this.navigateTo('/u/product/place', state.source === '4')}>
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                    产地
                                </div>
                                    <div className="expert-editgroup">
                                        <p className={props.country ? 'active' : ''}>
                                            {props.country ? (props.country === '1' ? (props.addressInfo.province.name + props.addressInfo.city.name) : props.foreignAddress) : '请选择'}
                                        </p>
                                        {
                                            state.source !== '4' ?
                                                <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                        }
                                    </div>
                                </div>
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        颜色
                                </div>
                                    <div className="expert-editgroup">
                                        <input type="text" placeholder="请输入" onChange={() => this.inputAction('color')} value={props.color} readOnly={state.source === '4'} />
                                    </div>
                                </div>
                                {
                                    state.type === '1' ?
                                        <div className="expert-edititem" onClick={() => this.selectAppearance()}>
                                            <div className="expert-editlabel">
                                                <span>*</span>
                                    外观
                                </div>
                                            <div className="expert-editgroup">
                                                <p className={props.appearance ? 'active' : ''}>{props.appearance ? ['固态', '液态', '气态', '粉末'][props.appearance - 1] : '请选择'}</p>
                                                {
                                                    state.source !== '4' ?
                                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                                                }
                                            </div>
                                        </div> : null
                                }
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        保质期
                                </div>
                                    <div className="expert-editgroup">
                                        <input type="text" placeholder="请输入" onChange={() => this.inputAction('period')} value={props.period} readOnly={state.source === '4'} />
                                    </div>
                                </div>
                            </div>
                            <div className="ylk-edit-wrapper">
                                <div className="expert-edititem" onClick={() => this.uploadFile('logo')}>
                                    <div className="expert-editlabel">
                                        <p>企业LOGO</p>
                                        <p><em>(图片尺寸：180x60像素)</em></p>
                                    </div>
                                    <div className="expert-editgroup">
                                        <div className="upload">
                                            {
                                                props.logo ? <img src={props.logo.indexOf('http') > -1 ? props.logo : (config.ULKAPI + props.logo)} alt="" /> : null
                                            }
                                            <span>+</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="expert-edititem" onClick={() => this.navigateTo('/u/product/storage?source=' + state.source, false)}>
                                    <div className="expert-editlabel">
                                        储存条件
                                </div>
                                    <div className="expert-editgroup">
                                        <p className={props.storage ? 'active' : ''}>{props.storage ? '已填写' : '请填写'}</p>
                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                                    </div>
                                </div>
                                <div className="expert-edititem" onClick={() => this.navigateTo('/u/product/performance?source=' + state.source, false)}>
                                    <div className="expert-editlabel">
                                        性能特点
                                </div>
                                    <div className="expert-editgroup">
                                        <p className={this.renderPerformance().write ? 'active' : ''}>{this.renderPerformance().text}</p>
                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                                    </div>
                                </div>
                            </div>
                        </section> : null
                }
                {
                    state.type === '1' && props.step === 5 ?
                        <section className="ylk-edit-block">
                            <div className="ylk-edit-wrapper">
                                <div className="expert-edititem">
                                    <div className="expert-editlabel">
                                        <span>*</span>
                                        性能参数
                                    </div>
                                    {
                                        state.source !== '4' ?
                                            <div className="expert-editgroup">
                                                <button className="formula-plus" onClick={() => this.addParameter()}><i>+</i>添加</button>
                                            </div> : null
                                    }
                                </div>
                                {
                                    props.parameter.map((v: any, k: number) => {
                                        return (
                                            <div className="expert-edititem" key={k} onClick={() => this.navigateTo(`/u/product/physical?index=${k}&source=${state.source}`, false)}>

                                                {
                                                    v.name ?
                                                        <div className="expert-editgroup formula-select">
                                                            <p className="active" dangerouslySetInnerHTML={{ __html: `${v.name} ${v.physical} ${v.unit} ${v.remarks}` }}></p>
                                                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /></div>
                                                        :
                                                        <div className="expert-editgroup formula-select"><p>请选择</p>
                                                        </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </section> : null
                }
                <div className="expert-editbottom">
                    {
                        (state.type === '1' && props.step < 5) || (state.type === '2' && props.step < 3) ? <button className="btn-submit" onClick={() => this.nextAction()}>下一步</button> : null
                    }
                    {
                        state.source !== '4' && ((state.type === '1' && props.step === 5) || (state.type === '2' && props.step === 3)) ? <button className="btn-submit" onClick={() => this.nextAction()}>发布</button> : null
                    }
                    {
                        props.step > 1 ? <button className="btn-prev" onClick={() => props.prevAction()}>上一步</button> : null
                    }
                </div>
                <ActionSheet project="ylk"/>
                <CategoryProduct />
                <CategoryApp />
            </section>
        )
    }

    // 选择外观
    private selectAppearance() {

        if (this.state.source === '4') {
            return;
        }

        (PickerBox as any).open({
            data: [{
                displayValue(item: any) {
                    return item.name;
                },
                list: this.state.appearanceList,
            }],
            // 成功回调
            onConfrim: (data: any) => {
                store.dispatch({
                    type: ProductEditStore.types.INPUT,
                    data: {
                        key: 'appearance',
                        value: data.value
                    }
                });
            }
        });

    }

    /**
     * 上传
     * @param type 
     */
    private uploadFile(type: string) {
        const that = this
        if (this.state.source === '4') {
            return;
        }

        if (type === 'logo') {
            return store.dispatch({
                type: types.ACTIONSHEET_SHOW,
                callback(r: any) {
                    if (r.flag === 1) {
                        store.dispatch({
                            type: ProductEditStore.types.INPUT,
                            data: {
                                key: 'logo',
                                value: r.data.url
                            }
                        });
                    } else {
                        Toast.T.notify(r.msg);
                    }
                }
            });
        }

        store.dispatch({
            type: types.ACTIONSHEET_SHOW,
            data: {
                type: 'file',
                formData: {}
                // formData: type === 'tds' ? {tds: 1} : {}
            },
            callback(r: any) {
                if (r.flag === 1) {
                    // 如果是tds
                    if (type === 'tds' && r.data.openAi !== '0') {
                        that.fillAiData(r.data.openAi)
                    }
                    store.dispatch({
                        type: ProductEditStore.types.INPUT,
                        data: {
                            key: type,
                            value: r.data.url
                        }
                    });
                } else {
                    Toast.T.notify(r.msg);
                }
            }
        });

    }

    private fillAiData(data: any) {
        store.dispatch({
            type: ProductEditStore.types.CONCAT,
            concatData: {
                brand: data.brand,
                model: data.grade,
                color: data.COLOUR,
                period: data.SHELF_LIFE,
                storage: data.STORAGE_CONDITION,
                performance: [ data.product_characteristics ],
                appearance: data.physical_form
            }
        });
    } 

    /**
     * 选择产品分类
     * @param index {number} 索引
     */
    private selectProductCategory(index: number) {
        if (this.state.source === '4') {
            return;
        }
        store.dispatch({
            type: categoryProductReducer.types.CATEGORY_PRODUCT_SHOW,
            showData: {
                init: this.props.proCategory[index],
                onConfirm: (item: any) => {

                    const temp = this.props.proCategory;
                    temp[index] = item;
                    setTimeout(() => {
                        store.dispatch({
                            type: ProductEditStore.types.INPUT,
                            data: {
                                key: 'proCategory',
                                value: temp
                            }
                        });
                    });
                    if (index === 0 && temp[0].lv2.product_id) {
                        const ids = `product_id[]=${temp[0].lv2.product_id}`;
                        this.getPhysical(ids);
                    }

                }
            }
        });

    }

    // 发布
    private async submitAction() {

        const props = this.props;

        let data = `pic_path4=&product_name=${props.productName}&product_english_name=${props.productEnName}&brand=${props.brand}&grade=${props.model}&COLOUR=${props.color}&SHELF_LIFE=${props.period}&foreign=${props.country}&foreign_address=${props.foreignAddress}&provice=${props.addressInfo.province.id || ''}&city=${props.addressInfo.city.id || ''}&pic_path5=${props.logo}&publish_status=1&idEdit=${this.state.id}&PRODUCT_ID=${this.state.id}&product_equipment=${this.state.type}&source=${this.state.source}&RECOMMEND_STATUS=0&munufacturer_id=${props.munufacturer_id}&munufacturer_abbreviation=${props.munufacturer_abbreviation}&munufacturer_name=${props.munufacturer_name}&STORAGE_CONDITION=${props.storage}`;

        props.proCategory.forEach((v: any) => {
            data += `&product_cate_one[]=${v.lv1.product_id || 0}&product_cate_two[]=${v.lv2.product_id || 0}&product_cate_three[]=${v.lv3.product_id || 0}`;
        });

        props.performance.forEach((v: string) => {
            data += `&product_characteristics[]=${v}`;
        });

        if (this.state.type === '1') {
            data += `&physical_form=${props.appearance}&molecular_formula=${props.chemicalFormula}&chemical_name_product=${props.chemicalName}&molecular_weight=${props.molecular}&cas_number=${props.cas}&product_description=${props.desc}&product_formula_open=0&tdsUrl=${props.tds}&msdsUrl=${props.msds}`;

            props.appCategory.forEach((v: any) => {
                data += `&application_cate_one[]=${v.lv1.id || 0}&application_cate_two[]=${v.lv2.id || 0}&application_cate_three[]=${v.lv3.id || 0}&application_cate_four[]=${v.lv4.id || 0}`;
            });

            props.parameter.forEach((v: any, k: number) => {
                data += `&product_physical_box1[]=${k + 1}&product_physical_box2[]=${v.id}&product_physical_box3[]=${v.physical}&product_physical_box4[]=${v.unitId}&product_physical_box5[]=${v.remarks}&product_physical_box6[]=${v.name}`;
            });
        }

        const r = await request({
            url: config.ULKAPI + (this.state.type === '1' ? 'api/web/index.php?r=member/product/add-material' : 'api/web/index.php?r=member/product/add-equipment'),
            method: 'post',
            data,
        });

        if (r.error_code === 0) {
            Toast.T.notify('发布成功');
            setTimeout(() => {
                store.dispatch({
                    type: ProductEditStore.types.CLEAR
                });
                this.props.history.replace('/u/');
            }, 1500);
        } else {
            Toast.T.notify(r.msg);
        }

    }

    // 添加一个产品分类
    private addCategory() {

        const temp = this.props.proCategory;

        if (temp.length > 2) {
            return Toast.T.notify('产品分类最多只能添加3个');
        }


        temp.push({
            lv1: '',
            lv2: '',
            lv3: ''
        });
        setTimeout(() => {
            store.dispatch({
                type: ProductEditStore.types.INPUT,
                data: {
                    key: 'proCategory',
                    value: temp
                }
            });
        });

    }

    /**
     * 删除一个产品分类
     * @param e {any} 事件
     * @param index {number} 索引
     */
    private removeCategory(e: any, index: number) {

        e.stopPropagation();
        const temp = this.props.proCategory;
        temp.splice(index, 1);

        setTimeout(() => {
            store.dispatch({
                type: ProductEditStore.types.INPUT,
                data: {
                    key: 'proCategory',
                    value: temp
                }
            });
        });

    }

    /**
     * 选择应用分类
     * @param index {number} 索引
     */
    private selectAppCategory(index: number) {

        if (this.state.source === '4') {
            return;
        }

        store.dispatch({
            type: categoryAppReducer.types.CATEGORY_APP_SHOW,
            showData: {
                init: this.props.appCategory[index],
                onConfirm: (item: any) => {
                    const temp = this.props.appCategory;
                    temp[index] = item;

                    setTimeout(() => {
                        store.dispatch({
                            type: ProductEditStore.types.INPUT,
                            data: {
                                key: 'appCategory',
                                value: temp
                            }
                        });
                    });
                }
            }
        });

    }

    // 添加一个应用分类
    private addAppCategory() {

        const temp = this.props.appCategory;
        temp.push({
            lv1: '',
            lv2: '',
            lv3: '',
            lv4: ''
        });

        setTimeout(() => {
            store.dispatch({
                type: ProductEditStore.types.INPUT,
                data: {
                    key: 'appCategory',
                    value: temp
                }
            });
        });

    }

    /**
     * 输入处理
     * @param modelName {string} 模块名称
     */
    private inputAction(modelName: string) {

        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: modelName,
                value: (event as any).target.value
            }
        });

    }

    /**
     * 删除一个应用分类
     * @param e {any} 事件
     * @param index {number} 索引
     */
    private removeAppCategory(e: any, index: number) {

        e.stopPropagation();
        const temp = this.props.appCategory;
        temp.splice(index, 1);

        setTimeout(() => {
            store.dispatch({
                type: ProductEditStore.types.INPUT,
                data: {
                    key: 'appCategory',
                    value: temp
                }
            });
        });

    }

    // 下一步
    private nextAction() {

        const props = this.props;
        const state = this.state;

        if (state.source === '4') {
            return props.nextAction();
        }

        if (props.step === 1) {

            let message = '';
            if (state.type === '1') {
                for (let i = 0; i < props.appCategory.length; i++) {
                    if (!props.appCategory[i].lv1.id) {
                        message = `请选择第${i + 1}个应用分类`;
                        break;
                    }
                }
            }
            for (let i = 0; i < props.proCategory.length; i++) {
                if (!props.proCategory[i].lv1.product_id) {
                    message = `请选择第${i + 1}个产品分类`;
                    break;
                }
            }

            if (message !== '') {
                return Toast.T.notify(message);
            }

        } else if (props.step === 2) {

            if (props.productName === '') {
                return Toast.T.notify('请填写产品中文名称');
            } else if (!/[\u4e00-\u9fa5]/img.test(props.productName)) {
                return Toast.T.notify('产品中文名称必须包含中文');
            } else if (props.productName.length > 200) {
                return Toast.T.notify('产品中文名称最多200个字');
            } else if (/[\u4e00-\u9fa5]/img.test(props.productEnName)) {
                return Toast.T.notify('产品英文名称不能包含中文');
            } else if (props.productEnName && props.productEnName.length > 400) {
                return Toast.T.notify('产品英文名称最多400个字');
            } else if (props.chemicalName !== '' && !/[\u4e00-\u9fa5]/img.test(props.chemicalName)) {
                return Toast.T.notify('产品化学名称必须包含中文');
            } else if (props.chemicalName.length > 200) {
                return Toast.T.notify('产品化学名称最多200个字');
            } else if (/[\u4e00-\u9fa5]/img.test(props.chemicalFormula)) {
                return Toast.T.notify('化学式不能包含中文');
            } else if (props.chemicalFormula.length > 200) {
                return Toast.T.notify('化学式最多200个字');
            } else if (/[\u4e00-\u9fa5A-Za-z]/img.test(props.molecular)) {
                return Toast.T.notify('分子量只能由数字、符号组成');
            } else if (props.molecular.length > 200) {
                return Toast.T.notify('分子量最多200个字');
            } else if (/[\u4e00-\u9fa5]/img.test(props.cas)) {
                return Toast.T.notify('cas不能包含中文');
            } else if (props.cas.length > 200) {
                return Toast.T.notify('cas最多200个字');
            }

        } else if ((state.type === '1' && props.step === 4) || (state.type !== '1' && props.step === 3)) {
            if (props.munufacturer_id === '') {
                return Toast.T.notify('请选择供应商');
            } else if (props.brand === '') {
                return Toast.T.notify('请填写牌号');
            } else if (props.brand.length > 200) {
                return Toast.T.notify('牌号最多只能200个字');
            } else if (props.model === '') {
                return Toast.T.notify('请填写产品型号');
            } else if (props.model.length > 200) {
                return Toast.T.notify('产品型号最多只能200个字');
            } else if (props.country === '') {
                return Toast.T.notify('请选择产地');
            } else if (props.color.length > 10) {
                return Toast.T.notify('颜色最多只能10个字');
            } else if (state.type === '1' && props.appearance === '') {
                return Toast.T.notify('请选择外观');
            } else if (props.period !== '') {
                if (!/^[\u4e00-\u9fa5A-Za-z0-9]+$/img.test(props.period)) {
                    return Toast.T.notify('保质期只能由汉字、英文、数字组成');
                } else if (props.period.length > 200) {
                    return Toast.T.notify('保质期最多只能200个字');
                }
            }

        }

        if (state.type === '1' && props.step === 5) {

            let message = '';
            for (let i = 0; i < props.parameter.length; i++) {
                if (!props.parameter[i].id) {
                    message = `请选择第${i + 1}个性能参数`;
                    break;
                }
                if (!props.parameter[i].name) {
                    message = `请填写第${i + 1}个性能参数名称`;
                    break;
                }
                if (!props.parameter[i].physical) {
                    message = `请填写第${i + 1}个性能参数物性值`;
                    break;
                }
                if (!props.parameter[i].unitId) {
                    message = `请选择第${i + 1}个性能参数单位`;
                    break;
                }
            }

            if (message !== '') {
                return Toast.T.notify(message);
            }

        }

        if ((state.type === '1' && props.step === 5) || (state.type === '2' && props.step === 3)) {
            this.submitAction();
        } else {
            props.nextAction();
        }

    }

    /**
     * 跳转
     * @param path {string} 路径
     */
    private navigateToManufacturer(path: string) {

        if (this.state.source === '3' || this.state.source === '4') {
            return;
        }

        this.props.history.push(path);

    }

    /**
     * 跳转
     * @param path {string} 路径
     * @param notJump {boolean} 是否不跳转
     */
    private navigateTo(path: string, notJump: boolean) {

        // if (this.state.source === '4') { 
        //     return;
        // }
        if (notJump) {
            return;
        }

        this.props.history.push(path);

    }

    /**
     * 渲染性能特点
     * @return {any} 结果
     */
    private renderPerformance() {

        const isWrite = this.props.performance.some((v: string) => v !== '');
        if (isWrite) {
            return {
                text: '已填写',
                write: true
            }
        } else {
            return {
                text: '请填写',
                write: false
            }
        }

    }

    // 添加性能参数
    private addParameter() {

        const temp = this.props.parameter;
        temp.push({
            id: '',
            name: '',
            physical: '',
            unit: '',
            unitId: '',
            remarks: '',
        });
        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: 'parameter',
                value: temp
            }
        });

    }

    private async getProInitData() {

        const r = await request({
            url: this.state.source === '4' ? `${config.ULKAPI}api/web/index.php?r=member/product/get-goods&logId=${this.state.id}&source=4` : `${config.ULKAPI}api/web/index.php?r=member/product/get-goods&id=${this.state.id}&source=3`
        });

        if (r.error_code === 0) {
            const data = r.data;
            const provinceList = await request({
                url: `${config.ULKAPI}api/web/index.php?r=index/regions&pCode=1`
            });
            if (provinceList.error_code === 0) {
                const obj = provinceList.data;
                for (let i = 0; i < obj.length; i++) {
                    if (data.PROVINCE == obj[i].id) {
                        data.provinceName = obj[i].name;
                        const cityList = await request({
                            url: `${config.ULKAPI}/api/web/index.php?r=index/regions&pCode=${obj[i].id}`
                        });
                        for (let j = 0; j < cityList.data.length; j++) {
                            if (data.CITY == cityList.data[j].id) {
                                data.cityName = cityList.data[j].name;
                            }
                        }
                    }
                }
            }

            const proCategory: any[] = [
                {
                    lv1: {},
                    lv2: {},
                    lv3: {}
                }
            ];
            const appCategory: any[] = [
                {
                    lv1: {},
                    lv2: {},
                    lv3: {},
                    lv4: {},
                }
            ];
            const parameter: any[] = [
                {
                    id: '', // 物性值id
                    name: '', // 名称
                    physical: '', // 物性值
                    unit: '', // 单位
                    unitId: '', // 单位id
                    remarks: '', // 备注
                }
            ];

            // 产品分类
            if (data.product_cate_one) {
                data.product_cate_one.forEach((v: any, k: number) => {
                    const name = data.product_cate_name[k] ? data.product_cate_name[k].split('>') : [];
                    proCategory[k] = {
                        lv1: {
                            product_id: v,
                            classification_name: name[0] || ''
                        },
                        lv2: {
                            product_id: data.product_cate_two[k],
                            classification_name: name[1] || ''
                        },
                        lv3: {
                            product_id: data.product_cate_three[k],
                            classification_name: name[2] || ''
                        }
                    };
                });
            }

            // 应用分类
            if (data.application_cate_one) {
                data.application_cate_one.forEach((v: any, k: number) => {
                    const name = data.application_cate_name[k] ? data.application_cate_name[k].split('>') : [];
                    appCategory[k] = {
                        lv1: {
                            id: v,
                            classification_name: name[0] || ''
                        },
                        lv2: {
                            id: data.application_cate_two[k],
                            classification_name: name[1] || ''
                        },
                        lv3: {
                            id: data.application_cate_three[k],
                            classification_name: name[2] || ''
                        },
                        lv4: {
                            id: data.application_cate_four[k],
                            classification_name: name[3] || ''
                        }
                    };
                });
            }

            // 物性参数
            if (data.product_physical && data.product_physical.length) {
                data.product_physical.forEach((v: any, k: number) => {
                    parameter[k] = {
                        id: v.id,
                        name: v.nature,
                        physical: v.units,
                        unit: v.unit,
                        unitId: v.unit_id,
                        remarks: v.condition,
                    };
                });
            }

            const initData = {
                proCategory,
                appCategory,
                productName: data.PRODUCT_NAME,
                productEnName: data.PRODUCT_ENGLISH_NAME,
                chemicalName: data.CHEMICAL_NAME,
                chemicalFormula: data.MOLECULAR_FORMULA,
                molecular: data.MOLECULAR_WEIGHT,
                cas: data.CAS_NUMBER,
                desc: data.PRODUCT_DESCRIPTION,
                munufacturer_id: data.MUNUFACTURER_ID,
                munufacturer_name: data.MUNUFACTURER_NAME,
                munufacturer_abbreviation: data.MUNUFACTURER_ABBREVIATION,
                brand: data.BRAND,
                model: data.GRADE,
                country: data.FOREIGN_ID,
                foreignAddress: data.FOREIGN_ADDRESS,
                addressInfo: {
                    province: {
                        id: data.PROVINCE,
                        name: data.provinceName || ''
                    },
                    city: {
                        id: data.CITY,
                        name: data.cityName || ''
                    }
                },
                color: data.COLOUR,
                period: data.SHELF_LIFE,
                appearance: data.PHYSICAL_FORM,
                logo: data.LOGO,
                storage: data.STORAGE_CONDITION,
                performance: data.PRODUCT_CHARACTERISTICS || [''],
                tds: data.TDS || '',
                msds: data.MSDS || '',
                parameter,
            }

            store.dispatch({
                type: ProductEditStore.types.INIT,
                initData,
            });

        }

    }

    // 获取供应商名称简称id
    private async getCompanyName() {
        const r = await request({
            method: "get",
            url: `${config.WAPAPI}safety/account/get`,
            data: {
                queryType: 1,
            }
        });

        if (r.code === 1) {
            if (r.obj && r.obj.companyInfo) {
                store.dispatch({
                    type: ProductEditStore.types.CONCAT,
                    concatData: {
                        logo: r.obj.companyInfo.logoUrl || '',
                        munufacturer_id: r.obj.companyInfo.id || '',
                        munufacturer_name: r.obj.companyInfo.company || '',
                        munufacturer_abbreviation: r.obj.companyInfo.companyNickName || ''
                    }
                });
            }

        }
    }

    /**
     * 根据二级分类自动获取物性特征
     * @param id {string} 二级分类id
     */
    private async getPhysical(id: string) {

        if (id === '') {
            return;
        }
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/product/product-aggregate`,
            method: 'post',
            data: id
        });
        if (r.error_code === 0) {

            const temp = this.props.parameter;

            r.data.forEach((v: any) => {
                temp.unshift({
                    id: v.product_physical_box2, // 物性值id
                    name: v.product_physical_box6, // 名称
                    physical: v.product_physical_box3, // 物性值
                    unit: v.product_physical_box4_units, // 单位
                    unitId: v.product_physical_box4, // 单位id
                    remarks: v.product_physical_box5, // 备注
                });
            });
            store.dispatch({
                type: ProductEditStore.types.INPUT,
                data: {
                    key: 'parameter',
                    value: temp
                }
            });

        }

    }
}

const mapStateToProps = (state: any): ProductEditStore.IProductEditState => {
    return {
        ...state.productEditReducers
    }
}

const mapDispatchToProps = (dispatch: Dispatch<ProductEditStore.IProductEditAction>) => {
    return bindActionCreators({ prevAction: ProductEditStore.prevAction, nextAction: ProductEditStore.nextAction }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductEdit);